// External libraries
import React from "react";

// Project components
import Spacer from "../../../../Components/Spacer";
import TextInput from "../../../../Components/Inputs/Text";
import { Text } from "../../../../Components/Text";

// Feature/context-specific hooks and constants
import { useRandomData } from "../../contexts/RandomDataContext";

/**
 * Component for configuring randomized data generation settings for seeding
 * Provides input fields for various random data parameters like admin counts, hierarchies, goals, etc.
 * @returns {JSX.Element} The randomized data configuration section
 */
const RandomizedDataSection = () => {
	const { randomDataConfig, updateRandomDataConfig, resetRandomDataConfig } = useRandomData();

	return (
		<div>
			<div>
				<Text variant="h2" weight="bold">
					Seed company with randomized data
				</Text>
				<div>
					<Text weight="bold">Number of Review Cycles</Text>
					<TextInput
						value={randomDataConfig.review_cycle}
						onChange={(val) => updateRandomDataConfig({ review_cycle: val })}
					/>
					<Spacer size={2} />
					<Text weight="bold">Number of Billing Admins</Text>
					<TextInput
						value={randomDataConfig.billing_admin}
						onChange={(val) => updateRandomDataConfig({ billing_admin: val })}
					/>
					<Spacer size={2} />
					<Text weight="bold">Number of Admins</Text>
					<TextInput
						value={randomDataConfig.admin}
						onChange={(val) => updateRandomDataConfig({ admin: val })}
					/>
					<Spacer size={2} />
					<Text weight="bold">Number of Basic Admins</Text>
					<TextInput
						value={randomDataConfig.basic_admin}
						onChange={(val) => updateRandomDataConfig({ basic_admin: val })}
					/>
					<Spacer size={2} />
					<Text weight="bold">Number of Employee Hierarchies</Text>
					<Spacer size={1} />
					<Text variant="caption">
						The total number of employee organizational structures you want to create. Think of each "tree"
						as a separate team or department.
					</Text>
					<TextInput
						value={randomDataConfig.employee_tree_count}
						onChange={(val) => updateRandomDataConfig({ employee_tree_count: val })}
					/>
					<Spacer size={2} />
					<Text weight="bold">Levels per Hierarchy</Text>
					<Spacer size={1} />
					<Text variant="caption">
						How many levels or layers each team has—like how many steps there are from the top manager down
						to the entry-level employees.
					</Text>
					<TextInput
						value={randomDataConfig.employee_branch_per_tree_count}
						onChange={(val) => updateRandomDataConfig({ employee_branch_per_tree_count: val })}
					/>
					<Spacer size={2} />
					<Text weight="bold">Number of Goals</Text>
					<TextInput
						value={randomDataConfig.goals}
						onChange={(val) => updateRandomDataConfig({ goals: val })}
					/>
					<Spacer size={2} />
					<Text weight="bold">Number of Review Forms</Text>
					<TextInput
						value={randomDataConfig.review_forms}
						onChange={(val) => updateRandomDataConfig({ review_forms: val })}
					/>
					<Spacer size={2} />
					<Text weight="bold">Percentage of Reviews with Answers</Text>
					<TextInput
						value={randomDataConfig.percentage_reviews_with_answers}
						onChange={(val) => updateRandomDataConfig({ percentage_reviews_with_answers: val })}
					/>
					<Spacer size={2} />
					<Text weight="bold">Percentage of Fully Answered Reviews</Text>
					<TextInput
						value={randomDataConfig.percentage_fully_answered_reviews}
						onChange={(val) => updateRandomDataConfig({ percentage_fully_answered_reviews: val })}
					/>
					<Spacer size={2} />
				</div>
			</div>
		</div>
	);
};

export default RandomizedDataSection;
